<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Norm-Cen__And__Page_Break"><span><img alt="" src="image0.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Norm-Cen"><span> </span></p>
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Readers love <span style=" font-size: 1.00em;">Charlie’s Hero </span>by Nic Starr</span></h1>
<p class="P_Norm-NoInd">“I love to see stories that show a family isn’t always just blood, but is about those you choose to have in your life that will be with you through anything and stand by you and love you unconditionally.”</p>
<p class="P_Normal">—The Novel Approach</p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-NoInd">“<span style=" font-style: italic; font-size: 1.00em;">Charlie’s Hero</span> is a nice steady romance between two men who smolder during intimacy.”</p>
<p class="P_Normal">—3 Chicks After Dark</p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-NoInd">“The storyline is really good, it keeps pace throughout and offers some interesting nuggets”</p>
<p class="P_Normal">—MM Good Book Reviews</p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-Cen__And__Justification"> </p>
<p class="P_Norm-NoInd">“This is the second book I’ve read from this author and I can see how she is improving her craft. The writing is smooth…”</p>
<p class="P_Normal">—Hearts on Fire</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?ce60e07e